"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _default = {
  "alba-adriatica": {
    "97cfd228": [{
      "hkey": "88026a0e",
      "slug": "alba-adriatica",
      "name": "Alba Adriatica",
      "primary": true,
      "skipSearch": false
    }],
    "villa-rosa": [{
      "hkey": "88026a0e",
      "slug": "alba-adriatica",
      "name": "Alba Adriatica",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 9,
      "slugLevelParent": null
    }],
    "a80a588d": [{
      "hkey": "88026a0e",
      "slug": "alba-adriatica",
      "name": "Alba Adriatica",
      "primary": true,
      "skipSearch": false
    }],
    "zona-mare": [{
      "hkey": "88026a0e",
      "slug": "alba-adriatica",
      "name": "Alba Adriatica",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 9,
      "slugLevelParent": null
    }]
  }
};
exports["default"] = _default;